/**
 * I limiti del piano visti dalla dashboard. Quando l'API rifiuta qualcosa
 * perche' il piano non lo comprende (402 con uno di questi codici), il client
 * (api/client.js) mette il messaggio in italiano e manda l'evento
 * EVENTO_LIMITE: AvvisoLimitePiano lo mostra in qualunque pagina, con la
 * strada per passare a un piano superiore.
 */

export const CODICI_LIMITE = [
  "bots_limit_reached",
  "quota_exceeded",
  "sources_limit_reached",
  "domains_limit_reached",
  "organizations_limit_reached",
];

export const EVENTO_LIMITE = "pingup:limite-piano";

/** L'errore dice che il piano non comprende quello che si sta facendo. */
export const eLimiteDelPiano = (err) => err?.status === 402 && CODICI_LIMITE.includes(err?.code);

/** Il resto disponibile di un limite (0 o assente = illimitato: Infinity). */
export const restanti = (limite, usati) => (limite > 0 ? Math.max(0, limite - (Number(usati) || 0)) : Infinity);
